// @flow
import { type Event, getEventCategoryAccessories } from './config';

const accessoryAddToCart = (productName: string, cartQuantity: number): Event => ({
  category: getEventCategoryAccessories(),
  action: 'Add to cart',
  label: `${productName} || ${cartQuantity}`,
});

const accessoryCustomiseRequest = (productName: string): Event => ({
  category: getEventCategoryAccessories(),
  action: 'Request customisation',
  label: `${productName}`,
});

export default {
  accessoryAddToCart,
  accessoryCustomiseRequest,
};
